<span class="kr-delete" v-bind="$attrs" :title="tooltip" @click="deleteCardHandler" v-html="icon"></span>